import {assert} from 'Asserts';
import {BaseStorablePaneStudyableState} from 'samples/BaseStorablePaneStudyableFormGroup';
import {CreateBoxPaneState} from 'samples/CreateBoxPane';
import {CreatePlatePaneState, CreatePlateSpreadsheetConfig} from 'samples/CreatePlatePane';
import {CreateGridParams} from 'samples/GridDAO';
import {getParentStorableData} from 'samples/storables/ParentStorableUtil';
import * as TagUtil from 'schemas/tags/TagUtil';
import {MakeAllFieldsOptional, MakeFieldsRequired} from 'util/Types';

export type CreateGridPaneState = MakeFieldsRequired<
  CreatePlatePaneState | CreateBoxPaneState,
  'selectedSchema' | 'registry'
> &
  MakeAllFieldsOptional<CreatePlateSpreadsheetConfig> &
  BaseStorablePaneStudyableState;

export default function getCreateGridParams({
  selectedSchema,
  name,
  customBarcode,
  selectedContainerSchema,
  selectedParent,
  sourceId,
  spreadsheetFile,
  spreadsheetURL,
  tags,
  studyIds,
}: CreateGridPaneState): CreateGridParams & {gridSchemaId: string; name: string} {
  const requiredArgs = {
    gridSchemaId: selectedSchema.id,
    name,
  };

  const optionalArgs = {sourceId, tags: TagUtil.getTagsToSet(tags)};
  if (customBarcode) {
    Object.assign(optionalArgs, {barcode: customBarcode});
  }
  if (spreadsheetFile) {
    assert(selectedContainerSchema != null, 'Expected container schema to be selected');
    Object.assign(optionalArgs, {
      containerSchemaId: selectedContainerSchema.id,
      spreadsheetName: spreadsheetFile.name,
      spreadsheetURL,
    });
  }
  if (selectedParent) {
    Object.assign(optionalArgs, {parentStorableData: getParentStorableData(selectedParent)});
  }
  if (studyIds?.length) {
    Object.assign(optionalArgs, {studyIds});
  }
  return {
    ...requiredArgs,
    ...optionalArgs,
  };
}
